<div class="container animated fadeIn">
    <div class="row">
        <div class="col-12">

            <div class="titleContainer fadeTitle">
                <h3 class="fw-sbold fs-35">¡Información legal de tu empresa!<br></h3>
                <p class="fs-14">En esta sección te solicitaremos que nos respondas algúnas preguntas para nuestra área de análisis</p>
            </div>

            <form [formGroup]="fourthFormDev" (ngSubmit)="nextStep()" class="fadeForm">
                <div class="mt-5">
                    <div class="my-4 first-container">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">El representante legal de la empresa es: <br><span class="cl-black fw-normal fs-14">{{fullName}}</span></label>
                        <mat-radio-group formControlName="isLegalRepresentative">
                            <mat-radio-button [value]="defaultOptions[0]" defaultOptions>Sí</mat-radio-button>
                            <mat-radio-button [value]="defaultOptions[1]" class="ms-0 ms-lg-3">No</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div *ngIf="forms.isLegalRepresentative.value === 'No'" class="fadeShow my-4">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">¿Cuál es el nombre del representante legal?</label>
                        <div class="col-5">
                            <mnf-input-form class="input-1" formControlName="name" label="Nombre(s)" placeholder="Ej: JUAN JESUS"  errMsg="Debe estar lleno éste campo"></mnf-input-form>
                        </div>
                        <div class="d-flex">
                            <div class="col-5">
                                <mnf-input-form class="input-1" formControlName="fatherSurname" label="Ap. Paterno" placeholder="Ej: MARTINEZ"  errMsg="Debe estar lleno éste campo"></mnf-input-form>
                            </div>
            
                            <div class="col-5 ms-4">
                                <mnf-input-form class="input-1" formControlName="motherSurname" label="Ap. Materno" placeholder="Ej: MORALES"  errMsg="Debe estar lleno éste campo"></mnf-input-form>
                            </div>
                        </div>
                    </div>

                    <div class="my-4">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">¿En que estado de operación se encuentra el hotel?</label>
                        <mat-radio-group formControlName="stateHotel">
                            <mat-radio-button [value]="stateHotelOptions[0]" stateHotelOptions>Construcción</mat-radio-button>
                            <mat-radio-button [value]="stateHotelOptions[1]" class="ms-0 ms-lg-3">Operación</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div class="mt-4 mb-0 col-12 col-sm-10 col-md-8 col-lg-10 col-xl-7 col-xxl-6">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">¿Cuál es el rango de tu ingreso anual en los últimos 12 meses?</label>
                        <mat-form-field appearance="outline" class="mnf-select">
                            <mat-select disableRipple formControlName="income12Months">
                               <mat-option value="">Seleccionar</mat-option>
                               <mat-option [value]="c.value" *ngFor="let c of income12MonthsOptions" [title]="c.value">
                                  {{ c.value }}
                               </mat-option>
                            </mat-select>
                         </mat-form-field>
                    </div>

                    <div *ngIf="forms.income12Months.value === 'Otros'" class="fadeShow mt-2 mb-3">
                        <div class="col-12 col-sm-10 col-md-8 col-lg-10 col-xl-7 col-xxl-6">
                            <mnf-input-form class="input-1" formControlName="income12MonthsOthers" label="Ingrese el monto" placeholder="Ej: $4,000,000.00" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                        </div>
                    </div>

                    <div class="mt-2 mb-3">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">¿Eres el operador del hotel?</label>
                        <mat-radio-group formControlName="isOperator">
                            <mat-radio-button [value]="defaultOptions[0]" defaultOptions>Sí</mat-radio-button>
                            <mat-radio-button [value]="defaultOptions[1]" class="ms-0 ms-lg-3">No</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div *ngIf="forms.isOperator.value === 'Si'" class="fadeShow my-4">
                        <div class="col-12 col-sm-10 col-md-8 col-lg-10 col-xl-7 col-xxl-6">
                            <mnf-input-form class="input-1" formControlName="operationYears" label="¿En qué año iniciaron operaciones?" mask="0000" placeholder="Ej: 2018" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                        </div>
                    </div>

                    <div class="my-4">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">¿Aproximadamente cuánto capital requieres?</label>
                        <mat-radio-group formControlName="requiredCapital">
                            <mat-radio-button [value]="requiredCapitalOptions[0]" requiredCapitalOptions>$0-$5 Millones de pesos</mat-radio-button>
                            <mat-radio-button [value]="requiredCapitalOptions[1]">$5-$40 Millones de pesos</mat-radio-button>
                            <mat-radio-button [value]="requiredCapitalOptions[2]">$40+ Millones de pesos</mat-radio-button>
                         </mat-radio-group>
                    </div>

                    <div class="my-4">
                        <label class="mnf-control-label fs-bold fs-13 pb-2">¿Cuál es el objetivo del financiamiento?</label>
                        <mat-radio-group formControlName="purposeFinancing">
                            <mat-radio-button [value]="purposeFinancingOptions[0]" purposeFinancingOptions>Construcción</mat-radio-button>
                            <mat-radio-button [value]="purposeFinancingOptions[1]">Remodelación</mat-radio-button>
                            <mat-radio-button [value]="purposeFinancingOptions[2]">Mejorar operación</mat-radio-button>
                            <mat-radio-button [value]="purposeFinancingOptions[3]">Otros</mat-radio-button>
                         </mat-radio-group>
                    </div>

                    <div *ngIf="forms.purposeFinancing.value === 'Otros'" class="my-4 fadeShow">
                        <div class="col-12">
                            <label class="mnf-control-label fs-bold fs-13 pb-2">Describa cuál sería el objetivo del financiamiento</label>
                            <textarea name="purposeFinancingOthers" class="p-2" placeholder="Describe..." id="purposeFinancingOthers" class="textArea" cols="30" rows="10" formControlName="purposeFinancingOthers"></textarea>
                        </div>
                    </div>

                </div>

                <div class="my-5">
                    <button mat-button (click)="returnToStep()"> ❮ </button>
                    <button mat-button type="submit" [disabled]="!fourthFormDev.valid" class="ms-3"> ❯ </button>
                </div>

            </form>

        </div>
    </div>
</div>